import { useMemo, useState } from 'react';
import { useInterval } from 'react-use';
import { getPctCompletion } from '@drift/common';
import ProgressIndicator from '../Toasts/MarketOrders/ProgressIndicator';

export const TimeoutProgressIndicator = ({
	startTimeMs,
	endTimeMs,
	size,
}: {
	startTimeMs: number;
	endTimeMs: number;
	size?: number;
}) => {
	const [currentMs, setCurrentMs] = useState(Date.now());

	useInterval(() => {
		setCurrentMs(Date.now());
	}, 1000);

	const pctComplete = getPctCompletion(startTimeMs, endTimeMs, currentMs);

	const strokeColour = useMemo<'warn' | 'neutral' | 'strong-warn'>(() => {
		if (pctComplete >= 80) {
			return 'strong-warn';
		}

		if (pctComplete >= 50) {
			return 'warn';
		}

		return 'neutral';
	}, [pctComplete]);

	return (
		<ProgressIndicator
			start={startTimeMs}
			end={endTimeMs}
			current={currentMs}
			direction="end-empty"
			type={strokeColour}
			size={size}
		/>
	);
};
